module.exports = __webpack_public_path__ + "img/user.10508617.svg";